export default __webpack_public_path__ + "static/media/train41.592f5581.png";